import { FormControl } from '@angular/forms';

export enum MCGROtherConservationActivitiesControlName {
  ScopeOfWork = 'scopeOfWork',
  Expenses = 'expenses',
  PublicFundsSubsidies = 'publicFundsSubsidies',
  Year = 'year',
}

export interface MCGROtherConservationActivitiesFormGroup {
  [MCGROtherConservationActivitiesControlName.Year]: FormControl<number>;
  [MCGROtherConservationActivitiesControlName.ScopeOfWork]: FormControl<string>;
  [MCGROtherConservationActivitiesControlName.Expenses]: FormControl<string>;
  [MCGROtherConservationActivitiesControlName.PublicFundsSubsidies]: FormControl<string>;
}

export interface OtherConservationActivity {
  [MCGROtherConservationActivitiesControlName.ScopeOfWork]: string;
  [MCGROtherConservationActivitiesControlName.Expenses]: string;
  [MCGROtherConservationActivitiesControlName.PublicFundsSubsidies]: string;
  [MCGROtherConservationActivitiesControlName.Year]?: number;
}

export class OtherConservationActivityDto {
  constructor(
    public ZakresPrac: string,
    public Wydatki: string,
    public DotacjeZeSrodkowPublicznych: string,
    public Rok?: number,
  ) {}

  static fromAppToApi(
    data: OtherConservationActivity,
  ): OtherConservationActivityDto {
    return new this(
      data.scopeOfWork,
      data.expenses,
      data.publicFundsSubsidies,
      data.year,
    );
  }
}
